import enviro from 'enviro';
import { useContext } from 'react';
import { SegmentationFiltersInstanceProvider } from '../../state/SegmentationFiltersInstanceContext';
import PropertyFilterUI from './PropertyFilterUI';
import emptyFunction from 'react-utils/emptyFunction';
import SegmentationFiltersSharedContext, { SegmentationFiltersSharedProvider } from '../../state/SegmentationFiltersSharedContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyFilter = ({
  additionalComponents,
  filterFamily,
  disabled,
  limitOperators,
  inputUse,
  multiCollapseLimit,
  onChange,
  precedingInputComponents,
  strategy: strategyFromProps,
  readOnly,
  requiredPropertyName,
  hidePropertySelect = false,
  use,
  value
}) => {
  var _useContext;
  // The type of SegmentationFiltersSharedContext is misleading; the optional chaining is necessary
  const strategyFromContext = (_useContext = useContext(SegmentationFiltersSharedContext)) === null || _useContext === void 0 || (_useContext = _useContext.props) === null || _useContext === void 0 ? void 0 : _useContext.strategy;
  if (strategyFromProps && strategyFromContext) {
    const errorMessage = 'Detected usage of `SegmentationFiltersSharedProvider`. Did you mean you to also pass the `strategy` prop to `PropertyFilter`?';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage, ' ', /*#__PURE__*/_jsx("a", {
          href: "https://product.hubteam.com/docs/crm-filters/pages/property-filter/intro.html",
          children: "Docs"
        })]
      });
    }
  }
  const foundStrategy = strategyFromProps !== null && strategyFromProps !== void 0 ? strategyFromProps : strategyFromContext;
  if (!foundStrategy) {
    const errorMessage = 'No detected usage of `SegmentationFiltersSharedProvider` and missing `strategy` prop. Please pass in a `strategy` prop to `PropertyFilter` or wrap with `SegmentationFiltersSharedProvider`.';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage, ' ', /*#__PURE__*/_jsx("a", {
          href: "https://product.hubteam.com/docs/crm-filters/pages/property-filter/intro.html",
          children: "Docs"
        })]
      });
    }
  }
  const filterQuery = foundStrategy.wrapSingleFilter(
  // @ts-expect-error wrapSingleFilter is not callable due to bad types
  value, filterFamily);
  const propertyFilterInstance = /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, {
    baseFilterFamily: filterFamily,
    value: filterQuery,
    onChange: emptyFunction,
    children: /*#__PURE__*/_jsx(PropertyFilterUI, {
      additionalComponents: additionalComponents,
      disabled: disabled,
      limitOperators: limitOperators,
      inputUse: inputUse,
      multiCollapseLimit: multiCollapseLimit,
      onChange: onChange,
      precedingInputComponents: precedingInputComponents
      // disabled `showExtraInputs` prop for now until a team asks for it
      // showExtraInputs={showExtraInputs}
      ,
      readOnly: readOnly,
      requiredPropertyName: requiredPropertyName,
      use: use,
      hidePropertySelect: hidePropertySelect
    })
  });
  if (strategyFromProps) {
    return /*#__PURE__*/_jsx(SegmentationFiltersSharedProvider, {
      strategy: strategyFromProps,
      children: propertyFilterInstance
    });
  } else {
    return propertyFilterInstance;
  }
};
export default PropertyFilter;